// Generate Referral Code
export const generateReferralCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < 8; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
};

// Format Currency (INR)
export const formatCurrency = (amount) => {
    const value = amount || 0;
    const hasDecimals = value % 1 !== 0;
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
    }).format(value);
};

// Format Date
export const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = date.toDate ? date.toDate() : new Date(date);
    return d.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
};

// Format DateTime
export const formatDateTime = (date) => {
    if (!date) return 'N/A';
    const d = date.toDate ? date.toDate() : new Date(date);
    return d.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

// Validate Email
export const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

// Validate Password (minimum 6 characters)
export const isValidPassword = (password) => {
    return password && password.length >= 6;
};

// Validate UTR (12 digits)
export const isValidUTR = (utr) => {
    const regex = /^\d{12}$/;
    return regex.test(utr);
};

// Validate Account Number (9-18 digits)
export const isValidAccountNumber = (accountNumber) => {
    const regex = /^\d{9,18}$/;
    return regex.test(accountNumber);
};

// Validate IFSC Code (11 alphanumeric)
export const isValidIFSC = (ifsc) => {
    const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return regex.test(ifsc.toUpperCase());
};

// Validate Fund Password (6 digits)
export const isValidFundPassword = (password) => {
    const regex = /^\d{6}$/;
    return regex.test(password);
};

// Get Days Remaining
export const getDaysRemaining = (expiryDate) => {
    if (!expiryDate) return 0;
    const expiry = expiryDate.toDate ? expiryDate.toDate() : new Date(expiryDate);
    const now = new Date();
    const diffTime = expiry.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
};

// Check if can claim today
export const canClaimToday = (lastClaimDate, purchaseDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to midnight for accurate date comparison

    // If there's a purchase date, check if product was purchased today
    if (purchaseDate) {
        const purchase = purchaseDate.toDate ? purchaseDate.toDate() : new Date(purchaseDate);
        purchase.setHours(0, 0, 0, 0);
        
        // If purchased today, cannot claim (must wait until next day)
        if (purchase.getTime() === today.getTime()) {
            return false;
        }
    }

    // If never claimed before and not purchased today, can claim
    if (!lastClaimDate) return true;

    // Check if last claim was on a different day
    const lastClaim = lastClaimDate.toDate ? lastClaimDate.toDate() : new Date(lastClaimDate);
    lastClaim.setHours(0, 0, 0, 0);

    return lastClaim.getTime() !== today.getTime();
};

// Mask Account Number
export const maskAccountNumber = (accountNumber) => {
    if (!accountNumber || accountNumber.length < 4) return accountNumber;
    const lastFour = accountNumber.slice(-4);
    const masked = '*'.repeat(accountNumber.length - 4);
    return masked + lastFour;
};

// Copy to Clipboard
export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (error) {
        console.error('Failed to copy:', error);
        return false;
    }
};

// Get Greeting Based on Time
export const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
};

export default {
    generateReferralCode,
    formatCurrency,
    formatDate,
    formatDateTime,
    isValidEmail,
    isValidPassword,
    isValidUTR,
    isValidAccountNumber,
    isValidIFSC,
    isValidFundPassword,
    getDaysRemaining,
    canClaimToday,
    maskAccountNumber,
    copyToClipboard,
    getGreeting,
};
